import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';

const AdminAction = ({ children }) => {
  const theme = useTheme();
  return (
    <span style={{ color: theme.palette.custom?.adminDark }}>{children}</span>
  );
};

AdminAction.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminAction;
